import { MDBCard, MDBCardBody, MDBCol, MDBIcon, MDBRow  , MDBFooter , MDBBtn } from 'mdbreact';
import React from 'react'
import axios from '../../../authAxios'
// import {useHistory } from 'react-router-dom';
import {  Redirect } from 'react-router-dom';

// const PaymentGateway = ({ mode, payArray }) => {
    export class PaymentGateway extends React.Component {

    // const history = useHistory()
    // console.log("Mode", mode);
    // console.log("PayArray", payArray);
    constructor(props) {
        super(props)

        this.state = {
            mode:'',
            application_reference_code:'',
            payArray:[],
            gotoTrack:false,
        }
        this.handlePaymentGateway = this.handlePaymentGateway.bind(this)
    }
    componentDidMount(){
        this.api_getApplicationDetails()
    }

    api_getApplicationDetails = (applicationId) => {
        //http://192.168.1.16:3000/visa-admin/getApplicationSummary?application_id=60013d16fcf15cf9664fac3f

        axios.get('visa-admin/getApplicationSummary' , {
            params : {
                application_id  : localStorage.getItem('application_id')
            },
        })
        .then((response)=> {
            // console.log("Response===>" , response.data.dataobj);
            
            var paymentConfig = response.data.dataobj.payment_config
            var paymentconf = paymentConfig[0].payment_config
            // console.log("mode===>" , this.state.mode);
            this.setState({mode:response.data.dataobj.payment_mode,
               payArray: paymentconf,
               application_reference_code:response.data.dataobj.application_reference_code})
             
        }).catch((error)=>{
            console.log(error);
        })
         

    }

      handlePaymentGateway = () =>{
    //    history.push("/track-application")
    this.setState({gotoTrack:true})
    }
    render() {
        if (this.state.gotoTrack) {
            return <Redirect to="/track-application" />
        }
    return (
        <>
        <MDBRow>
            <MDBCol>
                <MDBCard style={{}}>
                    <MDBCardBody>
                        <MDBRow>
                            <MDBCol className="text-center " style={{marginTop : "5%" , marginBottom : "10%"}}>
                                <MDBIcon far icon="check-circle"  style={{color : "green" , transform : "scale(8)"}} />
                            </MDBCol>
                        </MDBRow>
                        {this.state.mode === "pay_at_center" &&
                        <>
                        <MDBRow className="text-center">
                            <MDBCol>
                            Your application has been created successfully. You must make the payment within next 48 hours at our payment center.
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className="text-center">
                            <MDBCol>
                            The application would be submitted for processing only after the payment is done.
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol className="mt-5 text-center">
                                 Application tracking no. <span style={{fontWeight:"bolder"}} >{this.state.application_reference_code}</span>
                            </MDBCol>
                        </MDBRow>
                        </>
                        }

                        {
                            this.state.mode === "bank_transfer"  &&
                            <>
                            <MDBRow className="text-center">
                                <MDBCol>
                                Your application has been created successfully. You must make the payment within next 48 hours.
                                </MDBCol>
                            </MDBRow>
                            <MDBRow className="text-center">
                                <MDBCol>
                                    If you choose to pay through bank transfer, you must add the transaction number generated after the money is transferred . You can enter the transaction number against this visa application by visiting the track application screen.
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol className="text-center">
                                    The application would be submitted for processing only after the transaction number has been submitted.
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol className="mt-5 text-center">
                                     Application tracking no. <span style={{fontWeight:"bolder"}}>{this.state.application_reference_code}</span>
                                </MDBCol>
                            </MDBRow>
                            </>
                        }



                        {this.state.mode === "bank_transfer"  && 
                        <MDBRow>
                            <MDBCol className="text-left">
                                <h6 style={{fontWeight : "bolder"}}>Bank Details</h6>
                            </MDBCol>
                        </MDBRow>}
                        <MDBRow style={{marginTop : "5%"}}>
                             {this.state.mode === "bank_transfer"  && 
                            

                                            this.state.payArray.map((pay) => (

                                                <MDBCol lg="4">

                                                <MDBCard>
                                                    <MDBCardBody>

                                                        <MDBRow>
                                                            <MDBCol >
                                                            {pay.bank_details.split("\\l").map((info1)=>{
                                                                return (
                                                                    <p className="mb-0">{info1}</p>
                                                                )
                                                            })}
                                                            </MDBCol>
                                                        </MDBRow>
                                                    </MDBCardBody>
                                                </MDBCard>
                                            </MDBCol>
                                            ))
                                      }
                        </MDBRow>
                        {this.state.mode === "pay_at_center"  && 
                        <MDBRow>
                            <MDBCol className="text-left">
                                <h6 style={{fontWeight : "bolder"}}>Payment Centers</h6>
                            </MDBCol>
                        </MDBRow>}
                        <MDBRow>
                            {this.state.mode === "pay_at_center" && 
                              this.state.payArray.map((pay) => (


                                <MDBCol lg="4" md="4">

                                <MDBCard >
                                    <MDBCardBody>

                                        <MDBRow>
                                            <MDBCol>
                                            {pay.center_details.split("\\l").map((info1)=>{
                                                return (
                                                    <p className="mb-0">{info1}</p>
                                                )
                                            })}
                                            </MDBCol>
                                        </MDBRow>
                                    </MDBCardBody>
                                </MDBCard>
                            </MDBCol>


                            ))
                            }
                        </MDBRow>
                    </MDBCardBody>
                </MDBCard>
            </MDBCol>
        </MDBRow>

<MDBRow>
<MDBFooter style={{ background: "#fff", position: "fixed", bottom: "0px", width: "100%", zIndex: "1", left: "0", right: "0", borderTop: "1px solid #ccc", boxShadow: "0px 0 10px rgba(0, 0, 0, 0.2)" }} color="white" className="pb-1 pt-1 text-right">

    <MDBRow>
        <MDBCol size="12" xs="6" sm="6" md="8" lg="8" />
        <MDBCol size="12" sm="6" md="4" lg="4">
            <MDBBtn id="reviewBtn" style={{ color: 'white', backgroundColor: localStorage.getItem("brand_color"), fontSize: 'calc(8px + .5rem)', textTransform: 'none' }} color="none" onClick={()=>this.handlePaymentGateway()}>Continue</MDBBtn>
        </MDBCol>
    </MDBRow>
</MDBFooter>
</MDBRow>
</>
    )
                        }
}

export default PaymentGateway;
